import PageProtectedLayout from "../../components/Page/PageProtectedLayout";
import AccountAddOns from "./AddOns/AccountAddOns";
import { useTranslation } from '../../language';



export default function AddOnsWelcome() {

 const { t } = useTranslation();
        
return (

<PageProtectedLayout
    
    headline={t('page_hl_account')}
    specify={t('page_sp_your_addon_purchases')} 

     >
 
 {/* Main Page Content */}
      <AccountAddOns />

</PageProtectedLayout>

)}